'use client'

import React, { forwardRef, HTMLAttributes } from 'react'
import clsx from 'classnames'
import { Text } from '@/shared/ui'
import style from './disclaimer.module.scss'

interface DisclaimerProps extends HTMLAttributes<HTMLDivElement> {
  disclaimer: string | null
}

export const Disclaimer = forwardRef<HTMLDivElement, DisclaimerProps>((props, ref) => {
  const { className, disclaimer } = props

  return (
    <Text
      className={clsx(className, style.disclaimer)}
      type="t2"
      tagName="div"
      color="dark-070"
      __html={disclaimer ?? ''}
    />
  )
})

Disclaimer.displayName = 'Disclaimer'
